// extracted by mini-css-extract-plugin
export default {"loading":"privateMessage_loading__2iuOg","pcWrap":"privateMessage_pcWrap__bdfrV"};